export const NOTIFICATIONS_TYPES = {
  PUSH: "push", // value is used for filtration on the server
  SMS: "sms",
  EMAIL: "email",
};
